"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var times_1 = __importDefault(require("lodash/times"));
var recharts_1 = require("recharts");
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var inversify_react_1 = require("inversify-react");
var Colors_1 = require("@CommonFrontend/Styles/Colors");
var LineDotPill_1 = require("../Customise/LineDotPill");
var SingleXAxisLegend_1 = require("../Customise/SingleXAxisLegend");
var DefaultYAxis_1 = require("../Common/DefaultYAxis");
var DefaultXAxis_1 = require("../Common/DefaultXAxis");
var DefaultCartesianGrid_1 = require("../Common/DefaultCartesianGrid");
var SafeDivide_1 = require("@CommonFrontendBackend/Utils/SafeDivide");
var BAR_WIDTH = 34;
var DEFAULT_COLOR = Colors_1.ColorPalette.Purple;
var PILL_WIDTH = 72;
var PILL_HEIGHT = 28;
function LineAndBarChart(_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, colors = _a.colors, config = _a.config, barChartProportion = _a.barChartProportion;
    var _c = __read((0, react_1.useState)({ width: PILL_WIDTH, height: PILL_HEIGHT }), 2), pillDimensions = _c[0], setPillDimensions = _c[1];
    var lineDataMax = Math.max.apply(Math, __spreadArray([], __read(data.map(function (item) { return item.data.line; })), false)) * 1.2;
    var dataWithScaledBars = scaleBarData(data, barChartProportion);
    var isMobile = (0, inversify_react_1.useInjection)("isMobile")();
    var mobileBreakpoint = (0, inversify_react_1.useInjection)("mobileBreakpoint");
    function onResize(width) {
        if (width == null)
            return;
        var proportion = Math.min(1.0, width / mobileBreakpoint);
        setPillDimensions({ width: PILL_WIDTH * proportion, height: PILL_HEIGHT * proportion });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_resize_detector_1.default, { onResize: onResize, handleWidth: true, handleHeight: false }),
        react_1.default.createElement(recharts_1.ResponsiveContainer, { width: "100%", height: "100%" },
            react_1.default.createElement(recharts_1.ComposedChart, { data: dataWithScaledBars },
                (0, DefaultCartesianGrid_1.GetDefaultCartesianGrid)(),
                react_1.default.createElement(recharts_1.Legend, { content: function () { var _a; return react_1.default.createElement(SingleXAxisLegend_1.SingleXAxisLegend, { text: (_a = config === null || config === void 0 ? void 0 : config.xAxis) === null || _a === void 0 ? void 0 : _a.legend }); } }),
                (0, DefaultXAxis_1.GetDefaultXAxis)({ data: dataWithScaledBars, isMobile: isMobile }),
                (0, DefaultYAxis_1.GetDefaultYAxis)({
                    dataMax: lineDataMax,
                    yAxisId: 1,
                    config: config === null || config === void 0 ? void 0 : config.yAxis,
                    zeroOffset: barChartProportion,
                    isMobile: isMobile,
                }),
                react_1.default.createElement(recharts_1.YAxis, { hide: true, yAxisId: 2, domain: [0, 1.0 * DefaultYAxis_1.GROW_Y_DOMAIN] }),
                dataWithScaledBars[0].data.bars.map(function (_d, barIndex) { return (react_1.default.createElement(recharts_1.Bar, { key: "data.bars[".concat(barIndex, "]"), dataKey: "data.bars[".concat(barIndex, "]"), barSize: BAR_WIDTH, fill: (colors === null || colors === void 0 ? void 0 : colors.barColors[barIndex]) || DEFAULT_COLOR, yAxisId: 2, isAnimationActive: false },
                    react_1.default.createElement(recharts_1.LabelList, { position: "top", dataKey: "data.labels[".concat(barIndex, "]"), offset: 4, fill: (colors === null || colors === void 0 ? void 0 : colors.barColors[barIndex]) || DEFAULT_COLOR, fontSize: 14, fontWeight: 600 }))); }),
                react_1.default.createElement(recharts_1.Line, { yAxisId: 1, dataKey: "data.line", stroke: (colors === null || colors === void 0 ? void 0 : colors.lineColor) || DEFAULT_COLOR, isAnimationActive: false, dot: function (props) { return (react_1.default.createElement(LineDotPill_1.LineDotPill, __assign({}, props, { lineColour: (colors === null || colors === void 0 ? void 0 : colors.lineColor) || DEFAULT_COLOR, pillWidth: pillDimensions.width, pillHeight: pillDimensions.height }))); } })))));
}
exports.default = LineAndBarChart;
function scaleBarData(composedChartData, barChartProportion) {
    var paddedBarChartProportion = barChartProportion * 0.75;
    var datasetMaximums = (0, times_1.default)(composedChartData[0].data.bars.length).map(function (n) {
        return Math.max.apply(Math, __spreadArray([], __read(composedChartData.reduce(function (acc, next) {
            return acc.concat(next.data.bars[n]);
        }, [])), false));
    });
    return composedChartData.map(function (_a) {
        var data = _a.data, rest = __rest(_a, ["data"]);
        return (__assign({ data: __assign(__assign({}, data), { bars: data.bars.map(function (d, index) {
                    var maxValue = datasetMaximums[index];
                    var scaledToMaxValue = (0, SafeDivide_1.safeDivide)(d, maxValue, 5);
                    return scaledToMaxValue * paddedBarChartProportion;
                }) }) }, rest));
    });
}
